"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RowControlType = exports.RowBlockType = exports.TemplateRowBlockParameterEnumType = exports.TemplateRowBlockParameterType = void 0;
var TemplateRowBlockParameterType;
(function (TemplateRowBlockParameterType) {
    TemplateRowBlockParameterType["parameter"] = "parameter";
    TemplateRowBlockParameterType["control"] = "control";
})(TemplateRowBlockParameterType || (exports.TemplateRowBlockParameterType = TemplateRowBlockParameterType = {}));
var TemplateRowBlockParameterEnumType;
(function (TemplateRowBlockParameterEnumType) {
    TemplateRowBlockParameterEnumType["endDate"] = "endDate";
    TemplateRowBlockParameterEnumType["idChildObject"] = "idChildObject";
    TemplateRowBlockParameterEnumType["idObject"] = "idObject";
    TemplateRowBlockParameterEnumType["startDate"] = "startDate";
})(TemplateRowBlockParameterEnumType || (exports.TemplateRowBlockParameterEnumType = TemplateRowBlockParameterEnumType = {}));
var RowBlockType;
(function (RowBlockType) {
    RowBlockType["round3D"] = "round3D";
    RowBlockType["bar3D"] = "bar3D";
    RowBlockType["flipBar3D"] = "flipBar3D";
    RowBlockType["histogram"] = "histogram";
    RowBlockType["table"] = "table";
    RowBlockType["flipTable"] = "flipTable";
    RowBlockType["chart"] = "chart";
})(RowBlockType || (exports.RowBlockType = RowBlockType = {}));
var RowControlType;
(function (RowControlType) {
    RowControlType["droplist"] = "droplist";
    RowControlType["dropdown"] = "dropdown";
    RowControlType["multiselect"] = "multiselect";
    RowControlType["edit_int"] = "edit_int";
    RowControlType["edit_real"] = "edit_real";
    RowControlType["edit_text"] = "edit_text";
})(RowControlType || (exports.RowControlType = RowControlType = {}));
//# sourceMappingURL=template.js.map